// extracted by mini-css-extract-plugin
export default {"content":"header_content__EFyQa","button1":"header_button1__-OgI8","nav":"header_nav__VFT++","navbold":"header_navbold__+yVT+","a":"header_a__079LP"};